// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataPieChartSquareSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm9.25.005a.242.242 0 0 0-.25.245v5.5c0 .138.112.25.25.25h5.5c.138 0 .25-.112.245-.25a6 6 0 0 0-5.745-5.745zm-5.957 4.142A6 6 0 1 0 17.72 13.81a.24.24 0 0 0-.233-.31H16.42c-.106 0-.2.067-.239.165a4.503 4.503 0 0 1-5.113 2.738 4.5 4.5 0 0 1-.734-8.584.259.259 0 0 0 .166-.24V6.514a.24.24 0 0 0-.31-.233 6 6 0 0 0-3.897 3.867z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataPieChartSquareSolid;
